import { createFileRoute, redirect } from "@tanstack/react-router";
import { JaziaShell } from "@/components/jazia/JaziaApp";
import { LoanDetailPage } from "@/components/loans/LoanDetailPage";
import { requireAuth } from "@/lib/require-auth";

export const Route = createFileRoute("/loans_/$id")({
  beforeLoad: ({ params }) => {
    requireAuth();
    if (params.id === "apply") {
      throw redirect({ to: "/loans/apply/$step", params: { step: "amount" } });
    }
  },
  component: function LoanDetailRoute() {
    const { id } = Route.useParams();
    return (
      <JaziaShell page="loans">
        <LoanDetailPage id={id} />
      </JaziaShell>
    );
  },
});
